<template>
  <j-modal :title="title"
           :width="width"
           :visible="visible"
           switchFullscreen
           @ok="handleOk"
           :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
           @cancel="handleCancel"
           cancelText="关闭">
    <a-table ref="table"
             size="middle"
             :scroll="{x:true}"
             bordered
             rowKey="code"
             :columns="columns"
             :dataSource="dataSource"
             :pagination="ipagination"
             :loading="loading"
             :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,type:'radio'}"
             class="j-table-force-nowrap"
             @change="handleTableChange">
    </a-table>
  </j-modal>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { mixinDevice } from '@/utils/mixin'
export default {
  name: 'GiftProductInfoModal',
  mixins: [JeecgListMixin, mixinDevice],
  components: {},
  data() {
    return {
      title: '鏈接商品',
      width: 900,
      visible: false,
      disableSubmit: false,
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '商品编码',
          align: 'center',
          dataIndex: 'code',
        },
        {
          title: '商品名稱',
          align: 'center',
          dataIndex: 'name',
        },
      ],
      url: {
        list: '/gift/product/list',
      },
      /* table选中keys*/
      selectedRowKeys: [],
      /* table选中records*/
      selectionRows: [],
      code: '',
    }
  },
  methods: {
    open(code, app){
      this.visible = true;
      // 將傳入的 app 設置為查詢條件
      this.queryParam.app = app;
      this.selectedRowKeys = code ? [code] : [];
      // 重新加載數據
      this.loadData(1);
    },
    add() {
      this.visible = true
    },
    edit(record) {
      this.visible = true
    },
    close() {
      this.visible = false;
      this.queryParam = {};
      this.selectedRowKeys = [];
      this.selectionRows = [];
      this.$emit('close');
    },
    handleOk() {
      this.$emit('ok', this.code)
      this.visible = false
    },
    submitCallback() {
      this.$emit('ok')
      this.visible = false
    },
    handleCancel() {
      this.close()
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      console.log('selectedRowKeys :', selectedRowKeys[0])
      console.log('selectionRows :', selectionRows)
      this.selectedRowKeys = selectedRowKeys
      this.selectionRows = selectionRows
      this.code = selectionRows[0].code
    },
  },
}
</script>